import React, { useEffect, useState } from "react"
import { view } from "@risingstack/react-easy-state"
import { useHistory, Redirect } from "react-router-dom"
import styled from "styled-components"
import {
  EyeOutlined,
  InboxOutlined,
  DeleteOutlined,
  FileSearchOutlined,
  EditOutlined,
  DownOutlined,
} from "@ant-design/icons"
import {
  message,
  Button,
  Empty,
  Pagination,
  Table,
  List,
  Input,
  Tooltip,
  Modal,
  Upload,
  Popconfirm,
  Dropdown,
  Menu,
} from "antd"

import StyledBox from "components/common/styled-components/StyledBox"
import StyledList from "components/common/styled-components/StyledList"
import { staleWhileRevalidate, networkOnly } from "utils/render-strategies"
import globalStore from "store/index"
import BudgetsService from "services/users/budgets.service"

const StyledPageContent = styled.div`
  & > .action-buttons.top {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
`

const BudgetsIndexPage = (props) => {
  const history = useHistory()
  const pageState = globalStore.ui.configuration.budgets.index
  const [exporting, setExporting] = useState(false)
  const [importModalVisible, setImportModalVisible] = useState(false)
  const [fileList, setFileList] = useState([])
  const [importing, setImporting] = useState(false)
  const [exportingAuditReports, setExportingAuditReports] = useState(false)

  const accessibleFeatures = globalStore.currentUser?.accessible_features || []

  const [multipleDeleteIds,setMultipleDeleteIds]=useState()
  useEffect(() => {
    const fetchBudgets = async () => {
      const pageState = globalStore.ui.configuration.budgets.index

      await BudgetsService.index({ pageState })

      const { serverStatus, budgetsErrors } = pageState

      if (serverStatus.status !== 200) {
        message.error("Oops!! something went wrong")
        return
      }

      if (budgetsErrors) {
        message.error(budgetsErrors[0] || "Budgets couldn't be fetched.")
        return
      }
    }

    fetchBudgets()
  }, [])

  const repaginate = async (page, pageSize, bcsla = null) => {
    if (bcsla) {
      await BudgetsService.index({ pageState, page, pageSize, bcsla })
      return
    }
    await BudgetsService.index({ pageState, page, pageSize })
  }

  const handleCreate = () => {
    history.push("/configuration/budgets/new")
  }



  const openImportModal = () => {
    setImportModalVisible(true)
  }

  const handleImport = async () => {
    if (fileList.length === 0) return

    const tempState = {}

    const formData = new FormData()

    formData.append("file", fileList[0])

    setImporting(true)
    await BudgetsService.import({ pageState: tempState, formData })
    setImporting(false)

    setImportModalVisible(false)

    message.success(
      "Import started. Kindly check import page in Report Center to see imported incentives"
    )
  }

  const handleExport = async () => {
    const tempState = {}

    setExporting(true)
    await BudgetsService.export({ pageState: tempState })
    setExporting(false)

    message.success(
      "Export started. Kindly check export page in Report Center to see exported incentives"
    )
  }

  const handleExportAuditReports = async () => {
    const tempState = {}

    setExportingAuditReports(true)
    await BudgetsService.auditReports({ pageState: tempState })
    setExportingAuditReports(false)

    message.success(
      "Export started. Kindly check export page in Report Center to see exported audit reports"
    )
  }

  const handleExportAuditReport = async (budgetId) => {
    const tempState = {}

    await BudgetsService.auditReport({ pageState: tempState, budgetId })

    message.success(
      "Export started. Kindly check export page in Report Center to see exported audit reports"
    )
  }

  const handleCardItemClick = (budgetId) => {
    history.push(`/configuration/budgets/${budgetId}`)
  }

  const handleEdit = (budgetId) => {
    history.push(`/configuration/budgets/${budgetId}/edit`)
  }

  const handleDelete = async (budgetId) => {
    const tempState = {}

    await BudgetsService.delete({ pageState: tempState, budgetId })

    const { serverStatus } = tempState

    if (serverStatus.status !== 200) return

    globalStore.ui.configuration.budgets.index = {
      ...globalStore.ui.configuration.budgets.index,
      budgets: budgets.filter((budget) => budget.id !== budgetId),
    }
  }

    const handleMultipleDelete = async () => {

      const tempState = {}

      const postData = {
				budget: { ids: multipleDeleteIds },
			}

			await BudgetsService.multipleDestroy({ pageState: tempState, values: postData })
      const { message:messages, serverStatus,budgetErrors } = tempState

      if (serverStatus.status !== 200) {
        message.error('Budget could not be deleted.')
        return
      }
      if (budgetErrors) {
        message.error(budgetErrors)
        return
      }
				globalStore.ui.configuration.budgets.index = {
					...globalStore.ui.configuration.budgets.index,
					budgets: budgets.filter((budget) => !multipleDeleteIds.includes(budget.id)),
				}
      message.success(messages)
    }

  const exportButtonMenu = (
    <Menu>
      <Menu.Item key="0">
        <Button type="link" ghost loading={exporting} onClick={handleExport}>
          Export
        </Button>
      </Menu.Item>
      <Menu.Item key="1">
        <Button
          type="link"
          ghost
          loading={exportingAuditReports}
          onClick={handleExportAuditReports}
        >
          {exportingAuditReports
            ? "Exporting Audit Reports..."
            : "Export Audit Reports"}
        </Button>
      </Menu.Item>
    </Menu>
  )

  const {
    budgets,
    budgetsMeta,
    API_USERS_BUDGETS_INDEX_STATUS,
    displayType = "table",
  } = pageState

  const {
    total,
    page: currentPage,
    page_size: pageSize,
    criteria_keys,
  } = budgetsMeta || {}

  const renderList = () => {
    return (
      <StyledList>
        {budgets.map((ic) => (
          <div
            className="item-card"
            key={`item-card-${ic.id}`}
            onClick={() => handleCardItemClick(ic.id)}
          >
            <div className="details-box">
              <div className="name-box">
                <div className="name">{ic.name}</div>
                <div>{}</div>
              </div>
            </div>
            <div className="icon-box">
              <Button type="link">
                <EyeOutlined />
              </Button>
            </div>
          </div>
        ))}
      </StyledList>
    )
  }

  const renderContents = () => {
    if (budgets.length === 0) {
      return (
        <Empty>
          <Button type="primary" ghost onClick={handleCreate}>
            Create Budget
          </Button>
        </Empty>
      )
    }

    const pagination = (
      <Pagination
        current={currentPage}
        total={total}
        onChange={repaginate}
        onShowSizeChange={repaginate}
        pageSize={pageSize || 25}
        pageSizeOptions={[10, 25, 50, 100]}
      />
    )

    const tableColumns = [
      ...criteria_keys.map((ck) => ({
        title: ck,
        dataIndex: ck,
        key: ck,
        render: (filteredCriteria, row) => {
          if (!filteredCriteria) return "--" // if null
          if (!filteredCriteria[0]) return "--" // If [null]
          if (filteredCriteria.length === 0) return "---" // if []

          const dataSource = filteredCriteria.filter((fc) => fc) // FIXME: need to fix

          return (
            <List
              dataSource={dataSource}
              renderItem={(values) => {
                return values.join(", ")
              }}
            ></List>
          )
        },
      })),
      ...[
        {
          title: "Currency",
          dataIndex: "currency",
          key: "currency",
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          align: "center",
          render: (value, ic) => {
            return (
              <div>
                <Tooltip title="View">
                  <Button
                    type="link"
                    onClick={() => handleCardItemClick(ic.id)}
                  >
                    <EyeOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="Edit">
                  <Button type="link" onClick={() => handleEdit(ic.id)}>
                    <EditOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Are you sure to delete?"
                    onConfirm={() => handleDelete(ic.id)}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="link">
                      <DeleteOutlined />
                    </Button>
                  </Popconfirm>
                </Tooltip>
                <Tooltip title="Export audit report">
                  <Button
                    type="link"
                    onClick={() => handleExportAuditReport(ic.id)}
                  >
                    <FileSearchOutlined />
                  </Button>
                </Tooltip>
              </div>
            )
          },
        },
      ],
    ]

    const dataSource = budgets.map((ic) => {
      const retval = { ...ic, key: ic.id }
      criteria_keys.forEach((ck) => {
        retval[ck] = ic.criteria.map((conditions) => {
          const relevantCondition = conditions.find((c) => c.field === ck)
          if (!relevantCondition) return null
          return relevantCondition.values
        })
      })
      return retval
    })

    const rowSelection = {
			onChange: (_selectedRowKeys, selectedRows) => {
        setMultipleDeleteIds(selectedRows.map((data) => data.id))
			},
		}

    const renderTable = () => {
      return (
				<Table
					rowSelection={{
						type: 'checkbox',
						...rowSelection,
					}}
					columns={tableColumns}
					dataSource={dataSource}
					pagination={false}
					scroll={{
						x: 'max-content',
					}}></Table>
			)
    }

    const renderInfo = () => {
      if (displayType === "table") return renderTable()
      return renderList()
    }

    return (
      <div>
        {pagination}
        {networkOnly({
          status: API_USERS_BUDGETS_INDEX_STATUS,
          data: budgets,
          render: renderInfo,
        })}

        {pagination}
      </div>
    )
  }

  const renderPageContent = () => {
    const bcslaSearch = (
      <Input.Search
        placeholder="BCSLA"
        onSearch={(bcsla) => repaginate(1, pageSize, bcsla)}
        style={{ width: 200, marginBottom: "10px" }}
      />
    )

    return (
      <StyledPageContent>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{bcslaSearch}</div>
          <div className="action-buttons top">
            <Tooltip title="Create or update multiple records by upload">
              <Button onClick={openImportModal} style={{ marginRight: 10 }}>
                Import
              </Button>
            </Tooltip>
            <Dropdown overlay={exportButtonMenu}>
              <Button style={{ marginRight: 10 }}>
                Export <DownOutlined />
              </Button>
            </Dropdown>
            {/* <Tooltip title="Prepares report for download, available under export section">
              <Button
                loading={exporting}
                onClick={handleExport}
                style={{ marginRight: 10 }}
              >
                Export
              </Button>
            </Tooltip>
            <Tooltip title="Export audit reports for download, available under export section">
              <Button
                loading={exportingAuditReports}
                onClick={handleExportAuditReports}
                style={{ marginRight: 10 }}
              >
                {exportingAuditReports ? "Exporting Audit Reports..." : "Export Audit Reports"}
              </Button>
            </Tooltip> */}
            <Tooltip title="Delete Selected Budget">
              <Button type="primary" ghost onClick={handleMultipleDelete} style={{ marginRight: 10 }}>
                Delete Budget
              </Button>
            </Tooltip>
            <Tooltip title="Create a new record">
              <Button type="primary" ghost onClick={handleCreate}>
                Create Budget
              </Button>
            </Tooltip>
          </div>
        </div>

        <div className="content">{renderContents()}</div>
      </StyledPageContent>
    )
  }
  const handleSampleFileDownload = () => {
    window.open(
      "https://storage.googleapis.com/ps-in-images-compensation/images/pdf/1095/budget_importer_sample.xlsx?1630655022"
    )
  }

  const uploadProps = {
    accept:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    onRemove: (file) => {
      const index = fileList.indexOf(file)
      const newFileList = fileList.slice()
      newFileList.splice(index, 1)

      setFileList(newFileList)
    },
    beforeUpload: (file) => {
      setFileList([file])
      return false
    },
    fileList,
  }

  if (
    accessibleFeatures?.length > 0 &&
    !accessibleFeatures.includes("fitment-data-view")
  )
    return <Redirect to="/" />

  return (
    <div className="page-content budgets-page">
      <StyledBox>
        {staleWhileRevalidate({
          status: API_USERS_BUDGETS_INDEX_STATUS,
          data: budgets,
          render: renderPageContent,
        })}
      </StyledBox>
      <Modal
        title="Import"
        visible={importModalVisible}
        confirmLoading={importing}
        closable={false}
        maskClosable={false}
        destroyOnClose
        onOk={handleImport}
        okText="Import"
        onCancel={() => setImportModalVisible(false)}
      >
        <Upload.Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Please ensure data accuracy in your file for upload. After upload,
            each associated records will be updated directly.
          </p>
        </Upload.Dragger>
        <Button type="link" onClick={handleSampleFileDownload}>
          Sample Import File
        </Button>
      </Modal>
    </div>
  )
}

export default view(BudgetsIndexPage)
